var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9857_122344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.49805C7.836 4.49805 7.5 4.16205 7.5 3.74805C7.5 3.33405 7.836 2.99805 8.25 2.99805H23.25C23.664 2.99805 24 3.33405 24 3.74805C24 4.16205 23.664 4.49805 23.25 4.49805H8.25Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.498C7.836 13.498 7.5 13.162 7.5 12.748C7.5 12.334 7.836 11.998 8.25 11.998H23.25C23.664 11.998 24 12.334 24 12.748C24 13.162 23.664 13.498 23.25 13.498H8.25Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22.498C7.836 22.498 7.5 22.162 7.5 21.748C7.5 21.334 7.836 20.998 8.25 20.998H23.25C23.664 20.998 24 21.334 24 21.748C24 22.162 23.664 22.498 23.25 22.498H8.25Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.99805C0.673 5.99805 0 5.32505 0 4.49805V1.49805C0 0.671047 0.673 -0.00195312 1.5 -0.00195312H4.5C5.327 -0.00195312 6 0.671047 6 1.49805V4.49805C6 5.32505 5.327 5.99805 4.5 5.99805H1.5ZM1.5 4.49805H4.5V1.49805H1.5V4.49805Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15C0.673 15 0 14.327 0 13.5V10.5C0 9.673 0.673 9 1.5 9H4.5C5.327 9 6 9.673 6 10.5V13.5C6 14.327 5.327 15 4.5 15H1.5ZM1.5 13.5H4.5V10.5H1.5V13.5Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 23.998C0.673 23.998 0 23.325 0 22.498V19.498C0 18.671 0.673 17.998 1.5 17.998H4.5C5.327 17.998 6 18.671 6 19.498V22.498C6 23.325 5.327 23.998 4.5 23.998H1.5ZM1.5 22.498H4.5V19.498H1.5V22.498Z",
    stroke: "none",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9857_122344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListRegular);
export default __webpack_public_path__ + "static/media/list-regular.3553bf4e785a21e25e0c4b29eee60417.svg";
export { ForwardRef as ReactComponent };